import { useEffect, useCallback, useRef, useState, useMemo } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import AdminLayout from "../../layout/AdminLayout";
import {
  addCampaign,
  getCampaignById,
  updateCampaign,
} from "../../../api/campaigns.api";
import { errorMsg, success } from "../../../utils/notifications";
import Select from "react-select";
import { getAllCompanies } from "../../../api/companies.api";
import { useNavigate, useParams } from "react-router-dom";
import { baseURL } from "../../../api/api";
import {
  getRestaurantsWithScreens,
  getAllRestaurantsWithScreens,
} from "../../../api/restaurants.api";
import { getActiveDefaultPricing } from "../../../api/settings.api";
import {
  getVehiclesWithType,
  getAllVehiclesWithPricing,
} from "../../../api/vehicle.api";
import RestaurantDetailsModal from "../Resturants/RestaurantDetailsModal"; // Adjust path accordingly
import { getAllVehicleTypes } from "../../../api/vehicleType.api";
import { getActiveMobileLocations } from "../../../api/mobileLocation.api";
import { getAllVehiclePricings } from "../../../api/pricing.api";
const initialData = {
  name: "",
  video: "",
  startDate: "",
  endDate: "",
  numberOfScreens: "",
  numberOfWeeks: "",
  location: "",
  status: "",
  type: "",
  cost: "",
  paid: false,
  company: "",
  selectedRestaurants: [], // Store restaurant IDs
  selectedVehicles: [], // Store selected vehicle IDs
};

// Add this useEffect hook to fetch vehicle types
const statusValues = ["Pending Approval", "Approved"];
const typeValues = [
  { value: "restaurant", label: "Fixed Location" },
  { value: "vehicle", label: "Mobile Location" },
];

function AddCompaigns() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [saveCampaignLoading, setSaveCampaignLoading] = useState(false);
  const [addCampaignsData, setAddCampaignsData] = useState({
    type: null,
    selectedRestaurants: [],
  });
  const [isProcessingCheckbox, setIsProcessingCheckbox] = useState(false);
  const [loading, setLoading] = useState(false);
  const [vehicles, setVehicles] = useState({});
  const [restaurants, setRestaurants] = useState([]);
  const [availableScreensByType, setAvailableScreensByType] = useState([]);
  const [selectedRestaurantId, setSelectedRestaurantId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [screensPerVehicleType, setScreensPerVehicleType] = useState({});
  const [addCompaniesData, setAddCompaniesData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [numberOfScreensAvailable, setNumberOfScreensAvailable] =
    useState(null);

  const [endDate, setEndDate] = useState("");
  const [totalCost, setTotalCost] = useState(0);
  const inputRef = useRef(null);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [locationTypes, setlocationTypes] = useState([]);
  const [vehiclePricings, setVehiclePricings] = useState([]);
  const [locationCosts, setLocationCosts] = useState({}); // { locationId: cost }
  const [allRestaurantsData, setAllRestaurantsData] = useState([]);
  const [allVehiclesData, setAllVehiclesData] = useState([]); // NEW: Add state for all vehicles data
  const [defaultPricing, setDefaultPricing] = useState(null);
  // Add loading states to prevent multiple simultaneous calls
  const [isLoadingAllRestaurants, setIsLoadingAllRestaurants] = useState(false);
  const [isLoadingAllVehicles, setIsLoadingAllVehicles] = useState(false); // NEW: Add loading state for vehicles

  // 🔥 FIX 1: Properly memoize serviceLocationOptions with correct dependencies
  const memoizedServiceLocationOptions = useMemo(() => {
    return locationTypes.map((location) => ({
      value: location._id,
      label: location.name,
    }));
  }, [locationTypes]); // Only depend on locationTypes, not serviceLocationOptions

  // 🔥 FIX 2: Use useRef to track if we've already fetched data
  const hasFetchedAllRestaurants = useRef(false);
  const hasFetchedAllVehicles = useRef(false); // NEW: Add ref for vehicles
  useEffect(() => {
    // Fetch vehicle pricings
    getAllVehiclePricings()
      .then((res) => {
        setVehiclePricings(res?.data || []);
      })
      .catch((error) => {
        console.error("Error fetching vehicle pricings:", error);
      });
  }, []);

  useEffect(() => {
    getActiveDefaultPricing()
      .then((res) => {
        setDefaultPricing(res?.data || null);
      })
      .catch((error) => {
        console.error("Error fetching default pricing:", error);
      });
  }, []);

  useEffect(() => {
    getAllVehicleTypes()
      .then((res) => {
        setVehicleTypes(res?.data || []);
      })
      .catch((error) => {
        console.error("Error fetching vehicle types:", error);
      });
    getActiveMobileLocations()
      .then((res) => {
        setlocationTypes(res?.data || []);
      })
      .catch((error) => {
        console.error("Error fetching vehicle types:", error);
      });
  }, []);

  const serviceLocationOptions = locationTypes.map((location) => ({
    value: location._id, // This will be sent to the backend
    label: location.name, // This will be displayed in the dropdown
  }));
  function addWeeks(startDate, numberOfWeeks) {
    if (!startDate) {
      return "";
    }
    const date = new Date(startDate);
    date.setDate(date.getDate() + numberOfWeeks * 7 - 1);
    date.setHours(23, 59, 59);
    // Get year, month, and day components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    // Return the date in the desired format: YYYY-MM-DD
    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    getAllCompanies()
      .then((res) => {
        setAddCompaniesData(res?.data?.companies);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const fetchVehicles = useCallback(async () => {
    if (
      addCampaignsData.type?.value === "vehicle" &&
      addCampaignsData.location &&
      addCampaignsData.startDate &&
      addCampaignsData.numberOfWeeks
    ) {
      setLoading(true);
      try {
        const res = await getVehiclesWithType(
          addCampaignsData.location,
          addCampaignsData.startDate,
          addCampaignsData.numberOfWeeks
        );
        setVehicles(res?.data?.vehicles || {});
        setAvailableScreensByType(res?.data?.availableScreensByType || {});
      } catch (error) {
        console.error("Error fetching vehicles:", error);
      } finally {
        setLoading(false);
      }
    }
  }, [
    addCampaignsData.type?.value,
    addCampaignsData.location,
    addCampaignsData.startDate,
    addCampaignsData.numberOfWeeks,
  ]);

  useEffect(() => {
    fetchVehicles();
  }, [fetchVehicles]);

  const fetchRestaurants = useCallback(async () => {
    if (addCampaignsData.type?.value !== "restaurant") return;

    const { startDate, numberOfWeeks, location } = addCampaignsData;
    if (!startDate || !numberOfWeeks || !location) return;

    setLoading(true);
    try {
      const res = await getRestaurantsWithScreens(
        startDate,
        numberOfWeeks,
        location
      );
      const { availableRestaurants, allRestaurants } = res.data;
      setRestaurants(
        availableRestaurants?.length ? availableRestaurants : allRestaurants
      );
    } catch (error) {
      console.error("Error fetching restaurants:", error);
    } finally {
      setLoading(false);
    }
  }, [
    addCampaignsData.type?.value,
    addCampaignsData.startDate,
    addCampaignsData.numberOfWeeks,
    addCampaignsData.location,
  ]);

  useEffect(() => {
    fetchRestaurants();
  }, [fetchRestaurants]);

  useEffect(() => {
    if (id) {
      getCampaignById(id)
        .then((res) => {
          const campaignData = res?.data;
          const formattedStartDate = campaignData?.startDate.split("T")[0];
          const selectedCompany = addCompaniesData?.find(
            (company) => company?._id === campaignData?.company?._id
          );

          // Extract vehicle IDs from screensRunningOn array
          const existingVehicleIds =
            campaignData?.screensRunningOn
              ?.filter((screen) => screen.vehicle?._id) // Only get screens with valid vehicle IDs
              ?.map((screen) => screen.vehicle._id) || [];

          // Extract restaurant IDs from screensRunningOn array
          const existingRestaurantIds =
            campaignData?.screensRunningOn
              ?.filter((screen) => screen.restaurant?._id) // Only get screens with valid restaurant IDs
              ?.map((screen) => screen.restaurant._id) || [];

          const updatedCampaignData = {
            ...campaignData,
            startDate: formattedStartDate,
            company: selectedCompany
              ? { value: selectedCompany._id, label: selectedCompany.name }
              : null,
            status: campaignData?.status
              ? { value: campaignData.status, label: campaignData.status }
              : null,
            selectedRestaurants: existingRestaurantIds, // Set the existing restaurant IDs
            selectedVehicles: existingVehicleIds, // Set the existing vehicle IDs
            type: campaignData?.type
              ? { value: campaignData.type, label: campaignData.type }
              : null,
          };

          setAddCampaignsData(updatedCampaignData);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [id, addCompaniesData]);

  useEffect(() => {
    if (
      id &&
      addCampaignsData.selectedVehicles?.length > 0 &&
      Object.keys(vehicles).length > 0
    ) {
      // Group selected vehicles by type and set selectedVehicleTypes
      const selectedVehicleTypes = [];
      const screensPerType = {};

      // Iterate through vehicle types to find which ones have selected vehicles
      Object.keys(vehicles).forEach((vehicleType) => {
        const vehiclesOfThisType = vehicles[vehicleType] || [];
        const selectedVehiclesOfThisType = vehiclesOfThisType.filter(
          (vehicle) =>
            addCampaignsData.selectedVehicles.includes(vehicle.vehicleId)
        );

        if (selectedVehiclesOfThisType.length > 0) {
          selectedVehicleTypes.push(vehicleType);
          screensPerType[vehicleType] = selectedVehiclesOfThisType.length;
        }
      });

      // Update the state with the calculated vehicle types
      setAddCampaignsData((prev) => ({
        ...prev,
        selectedVehicleTypes: selectedVehicleTypes,
        numberOfScreens: addCampaignsData.selectedVehicles.length,
        numberOfScreensAvailable: addCampaignsData.selectedVehicles.length,
      }));

      setScreensPerVehicleType(screensPerType);
    }
  }, [id, addCampaignsData.selectedVehicles, vehicles]);

  useEffect(() => {
    if (
      id &&
      addCampaignsData.selectedRestaurants?.length > 0 &&
      restaurants.length > 0
    ) {
      // Update screen counts for restaurants
      setAddCampaignsData((prev) => ({
        ...prev,
        numberOfScreens: addCampaignsData.selectedRestaurants.length,
        numberOfScreensAvailable: addCampaignsData.selectedRestaurants.length,
      }));
    }
  }, [id, addCampaignsData.selectedRestaurants, restaurants]);

  useEffect(() => {
    if (!addCampaignsData.startDate || !addCampaignsData.numberOfWeeks) {
      setEndDate(""); // Keep empty if data is missing
      return;
    }

    const startDate = addCampaignsData.startDate;
    const numberOfWeeks = Number(addCampaignsData.numberOfWeeks);

    const calculatedEndDate = addWeeks(startDate, numberOfWeeks); // Already returns formatted date

    setEndDate(calculatedEndDate); // Directly set formatted string
  }, [addCampaignsData.startDate, addCampaignsData.numberOfWeeks]);

  useEffect(() => {
    // Only proceed if we have an ID and are dealing with restaurant campaigns
    if (
      !id ||
      addCampaignsData.type?.value !== "restaurant" ||
      !addCampaignsData.startDate ||
      !addCampaignsData.numberOfWeeks
    ) {
      return;
    }

    // Prevent multiple calls using ref
    if (hasFetchedAllRestaurants.current || isLoadingAllRestaurants) {
      return;
    }

    // Mark as fetching to prevent duplicate calls
    hasFetchedAllRestaurants.current = true;

    const fetchAllRestaurantsDataOnce = async () => {
      setIsLoadingAllRestaurants(true);
      try {
        // Use the single API call instead of multiple calls
        const response = await getAllRestaurantsWithScreens(
          addCampaignsData.startDate,
          addCampaignsData.numberOfWeeks
        );

        // Extract all restaurants from the response
        const allRestaurants = response.data.allRestaurants || [];

        setAllRestaurantsData(allRestaurants);
      } catch (error) {
        console.error("❌ Error fetching all restaurants data:", error);
        // Reset the ref so we can retry if there was an error
        hasFetchedAllRestaurants.current = false;
      } finally {
        setIsLoadingAllRestaurants(false);
      }
    };

    fetchAllRestaurantsDataOnce();
  }, [
    id,
    addCampaignsData.type?.value,
    addCampaignsData.startDate,
    addCampaignsData.numberOfWeeks,
  ]);

  // 🔥 NEW: Fetch all vehicles data for updates
  useEffect(() => {
    // Only proceed if we have an ID and are dealing with vehicle campaigns
    if (
      !id ||
      addCampaignsData.type?.value !== "vehicle" ||
      !addCampaignsData.startDate ||
      !addCampaignsData.numberOfWeeks
    ) {
      return;
    }

    // Prevent multiple calls using ref
    if (hasFetchedAllVehicles.current || isLoadingAllVehicles) {
      return;
    }

    // Mark as fetching to prevent duplicate calls
    hasFetchedAllVehicles.current = true;

    const fetchAllVehiclesDataOnce = async () => {
      setIsLoadingAllVehicles(true);
      try {
        const response = await getAllVehiclesWithPricing(
          addCampaignsData.startDate,
          addCampaignsData.numberOfWeeks
        );

        // Transform the API response into a flat array of vehicles with pricing
        const allVehicles = [];
        const vehicleTypesData = response.data.availableScreensByType || {};

        for (const [vehicleTypeName, typeData] of Object.entries(
          vehicleTypesData
        )) {
          if (typeData.vehicles && Array.isArray(typeData.vehicles)) {
            typeData.vehicles.forEach((vehicle) => {
              // Find the vehicle type in pricing data by NAME (not ID)
              const matchingPricing = vehiclePricings.find((p) => {
                // Check if vehicle type name matches
                const typeMatches = p.vehicleType?.name === vehicleTypeName;

                // Check if location matches - compare location names
                const locationMatches = p.location?.name === vehicle.location;

                return typeMatches && locationMatches;
              });

              // Use default pricing if no specific pricing found
              const basePricePerWeek = matchingPricing
                ? matchingPricing.basePricePerWeek
                : defaultPricing?.pricePerWeek || 0;

              allVehicles.push({
                _id: vehicle.vehicleId,
                vehicleType: {
                  _id: matchingPricing?.vehicleType?._id || vehicleTypeName,
                  name: vehicleTypeName,
                },
                location: {
                  _id: matchingPricing?.location?._id || vehicle.location,
                  name: vehicle.location,
                },
                name: vehicle.name,
                model: vehicle.model,
                basePricePerWeek: basePricePerWeek,
                availableScreens: vehicle.availableScreens,
              });
            });
          }
        }

        setAllVehiclesData(allVehicles);
      } catch (error) {
        console.error("❌ Error fetching all vehicles data:", error);
        hasFetchedAllVehicles.current = false;
      } finally {
        setIsLoadingAllVehicles(false);
      }
    };
    fetchAllVehiclesDataOnce();
  }, [
    id,
    addCampaignsData.type?.value,
    addCampaignsData.startDate,
    addCampaignsData.numberOfWeeks,
  ]);

  // Updated cost calculation useEffect
  useEffect(() => {
    const numberOfWeeks = Number(addCampaignsData.numberOfWeeks) || 0;

    // Early return if essential data is missing
    if (numberOfWeeks === 0) {
      setTotalCost(0);
      return;
    }

    // Don't calculate cost if we're still loading data for updates
    if (id) {
      if (
        addCampaignsData.type?.value === "restaurant" &&
        isLoadingAllRestaurants
      ) {
        return;
      }

      if (addCampaignsData.type?.value === "vehicle" && isLoadingAllVehicles) {
        return;
      }
    }

    // If we're updating an existing campaign (id exists), calculate total cost from all selected items
    if (id) {
      // RESET TOTAL COST TO 0 IF NO VEHICLES OR RESTAURANTS ARE SELECTED
      if (
        (addCampaignsData.type?.value === "restaurant" &&
          (!addCampaignsData.selectedRestaurants ||
            addCampaignsData.selectedRestaurants.length === 0)) ||
        (addCampaignsData.type?.value === "vehicle" &&
          (!addCampaignsData.selectedVehicles ||
            addCampaignsData.selectedVehicles.length === 0))
      ) {
        setTotalCost(0);
        return;
      }

      let totalCostForUpdate = 0;

      if (
        addCampaignsData.type?.value === "restaurant" &&
        addCampaignsData.selectedRestaurants?.length > 0
      ) {
        if (allRestaurantsData.length > 0) {
          totalCostForUpdate = addCampaignsData.selectedRestaurants.reduce(
            (total, restaurantId) => {
              const restaurant = allRestaurantsData.find(
                (r) => r._id === restaurantId
              );
              if (!restaurant) {
                console.warn(
                  `Restaurant ${restaurantId} data not available in all locations data`
                );
                return total;
              }

              return total + (restaurant.basePricePerWeek || 0) * numberOfWeeks;
            },
            0
          );
        } else {
          return;
        }
      } else if (
        addCampaignsData.type?.value === "vehicle" &&
        addCampaignsData.selectedVehicles?.length > 0
      ) {
        // NEW: Vehicle cost calculation using all vehicles data
        if (allVehiclesData.length > 0) {
          totalCostForUpdate = addCampaignsData.selectedVehicles.reduce(
            (total, vehicleId) => {
              const vehicle = allVehiclesData.find((v) => v._id === vehicleId);
              if (!vehicle) {
                console.warn(
                  `Vehicle ${vehicleId} data not available in all vehicles data`
                );
                return total;
              }

              const vehicleCost =
                (vehicle.basePricePerWeek || 0) * numberOfWeeks;

              return total + vehicleCost;
            },
            0
          );
        } else {
          return;
        }
      }

      setTotalCost(totalCostForUpdate);
      return;
    }

    // Original logic for new campaigns (current location only) - remains the same
    const locationObj = memoizedServiceLocationOptions.find(
      (loc) => loc.label === addCampaignsData.location
    );
    const locationId = locationObj?.value;

    if (!locationId) {
      setLocationCosts((prev) => {
        const newCosts = { ...prev };
        delete newCosts[locationId];
        return newCosts;
      });
      return;
    }

    let currentLocationCost = 0;

    if (addCampaignsData.type?.value === "restaurant") {
      if (
        addCampaignsData.selectedRestaurants?.length > 0 &&
        restaurants.length > 0
      ) {
        currentLocationCost = addCampaignsData.selectedRestaurants.reduce(
          (total, restaurantId) => {
            const restaurant = restaurants.find((r) => r._id === restaurantId);
            if (!restaurant) {
              console.warn(`Restaurant ${restaurantId} data not available`);
              return total;
            }
            return total + (restaurant.basePricePerWeek || 0) * numberOfWeeks;
          },
          0
        );
      }
    } else if (addCampaignsData.type?.value === "vehicle") {
      // Vehicle logic for new campaigns - UPDATED WITH DEFAULT PRICING
      if (
        addCampaignsData.selectedVehicleTypes?.length > 0 &&
        addCampaignsData.location &&
        Object.keys(vehicles).length > 0
      ) {
        currentLocationCost = addCampaignsData.selectedVehicleTypes.reduce(
          (total, vehicleType) => {
            if (!vehicles[vehicleType] || vehicles[vehicleType].length === 0) {
              console.warn(
                `Vehicle type ${vehicleType} not available in ${addCampaignsData.location}`
              );
              return total;
            }

            const pricing = vehiclePricings.find(
              (p) =>
                (p.vehicleType._id === vehicleType ||
                  p.vehicleType.name === vehicleType) &&
                p.location._id === locationId
            );

            // Use default pricing if no specific pricing found
            const pricePerWeek = pricing
              ? pricing.basePricePerWeek
              : defaultPricing?.pricePerWeek || 0;

            if (!pricing) {
            }

            const screensOfThisType = screensPerVehicleType[vehicleType] || 0;

            if (screensOfThisType > 0) {
              return total + pricePerWeek * screensOfThisType * numberOfWeeks;
            }

            return total;
          },
          0
        );
      }
    }

    setLocationCosts((prev) => ({
      ...prev,
      [locationId]: currentLocationCost,
    }));
  }, [
    addCampaignsData.type,
    addCampaignsData.selectedRestaurants,
    addCampaignsData.selectedVehicleTypes,
    addCampaignsData.selectedVehicles,
    addCampaignsData.numberOfWeeks,
    addCampaignsData.location,
    restaurants,
    allRestaurantsData, // This now contains data from all locations
    allVehiclesData, // NEW: This now contains vehicle data from all locations
    vehiclePricings,
    screensPerVehicleType,
    vehicles,
    id,
    isLoadingAllRestaurants,
    defaultPricing,
    isLoadingAllVehicles, // NEW: Add to dependencies
  ]);

  // Only run this for new campaigns (no id), not for updates - remains the same
  useEffect(() => {
    if (!id) {
      const total = Object.values(locationCosts).reduce(
        (sum, cost) => sum + cost,
        0
      );
      setTotalCost(total);
    }
  }, [locationCosts, id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    if (name === "numberOfScreens") {
      const newValue = parseInt(value, 10);
      if (newValue > numberOfScreensAvailable) {
        return;
      }
    }

    setAddCampaignsData({
      ...addCampaignsData,
      [name]: newValue,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const maxFileSize = 100 * 1024 * 1024; // 300MB in bytes

    // Check if file size exceeds 100MB
    if (file.size > maxFileSize) {
      setSelectedFile(null);
      errorMsg("Error", "Selected video exceeds 100MB file size limit.");
      return;
    }

    const video = document.createElement("video");
    video.onloadedmetadata = () => {
      const duration = video.duration;
      // Check if duration exceeds 20 seconds
      if (duration > 21) {
        setSelectedFile(null);
        errorMsg("Error", "Selected video exceeds 20 seconds duration.");
        return;
      }

      // Check video dimensions if type is "restaurant"
      if (
        addCampaignsData.type?.value === "restaurant" ||
        addCampaignsData.type?.value === "vehicle"
      ) {
        const width = video.videoWidth;
        const height = video.videoHeight;

        // Define max width and height for validation (adjust as needed)
        const maxWidth = 3840;
        const maxHeight = 2160;

        // Check if dimensions exceed limits
        if (width >= maxWidth || height >= maxHeight) {
          setSelectedFile(null);
          errorMsg(
            "Error",
            `Video dimensions exceed maximum allowed: ${maxWidth}x${maxHeight}.`
          );
          return;
        }

        // Validate orientation based on type
        const isPortrait = height > width; // True if portrait
        const isLandscape = width > height; // True if landscape

        if (addCampaignsData.type.value === "restaurant" && !isPortrait) {
          setSelectedFile(null);
          errorMsg("Error", "Please upload a portrait video.");
          return;
        }

        if (addCampaignsData.type.value === "vehicle" && !isLandscape) {
          setSelectedFile(null);
          errorMsg("Error", "Please upload a landscape video.");
          return;
        }
      }

      setSelectedFile(file);
    };

    // Set video source
    video.src = URL.createObjectURL(file);
  };
  useEffect(() => {
    if (!selectedFile) return;

    const video = document.createElement("video");
    video.preload = "metadata";

    video.onloadedmetadata = () => {
      const width = video.videoWidth;
      const height = video.videoHeight;

      const isPortrait = height > width;
      const isLandscape = width > height;

      if (addCampaignsData.type?.value === "restaurant" && !isPortrait) {
        setSelectedFile(null);
        // errorMsg("Error", "Restaurant campaigns require a portrait video.");
      }

      if (addCampaignsData.type?.value === "vehicle" && !isLandscape) {
        setSelectedFile(null);
        // errorMsg("Error", "Vehicle campaigns require a landscape video.");
      }
    };

    video.src = URL.createObjectURL(selectedFile);
  }, [addCampaignsData.type, selectedFile]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};

    if (!addCampaignsData.location) {
      errors.location = "Location is required.";
    }

    if (!id) {
      // Only validate restaurant/vehicle selection for new campaigns
      if (
        addCampaignsData?.type?.value === "restaurant" &&
        (!addCampaignsData.selectedRestaurants ||
          addCampaignsData.selectedRestaurants.length === 0)
      ) {
        errors.selectedRestaurants = "Please select at least one restaurant.";
      }

      if (
        addCampaignsData?.type?.value === "vehicle" &&
        (!addCampaignsData.selectedVehicles ||
          addCampaignsData.selectedVehicles.length === 0)
      ) {
        errors.selectedVehicles = "Please select at least one vehicle.";
      }
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    if (!selectedFile && !addCampaignsData?.video) {
      errorMsg("Error", "A video must be uploaded to proceed.");
      return;
    }

    setSaveCampaignLoading(true);
    try {
      const formData = new FormData();
      formData.append("name", addCampaignsData.name);
      if (selectedFile) {
        formData.append("video", selectedFile);
      }
      formData.append("startDate", addCampaignsData.startDate);
      formData.append("endDate", endDate);
      formData.append("numberOfWeeks", addCampaignsData.numberOfWeeks);

      const matchedLocation = serviceLocationOptions.find(
        (option) => option.label === addCampaignsData?.location
      );

      // This ensures that even if the location is still a label (from legacy data), it will resolve to ID
      formData.append(
        "location",
        matchedLocation?.value ||
          addCampaignsData?.location?.value ||
          addCampaignsData?.location
      );

      formData.append("status", addCampaignsData?.status?.value);
      formData.append("type", addCampaignsData?.type?.value);
      formData.append("company", addCampaignsData?.company?.value);
      formData.append("totalCost", totalCost);
      formData.append("paid", addCampaignsData?.paid || false);

      // Handle selected restaurants and vehicles
      if (addCampaignsData.type?.value === "restaurant") {
        formData.append(
          "selectedRestaurants",
          JSON.stringify(addCampaignsData.selectedRestaurants)
        );
        formData.append(
          "numberOfScreens",
          addCampaignsData.selectedRestaurants.length
        );
      } else if (addCampaignsData.type?.value === "vehicle") {
        formData.append(
          "selectedVehicles",
          JSON.stringify(addCampaignsData.selectedVehicles)
        );
        formData.append(
          "numberOfScreens",
          addCampaignsData.selectedVehicles.length
        );
      }

      if (id) {
        await updateCampaign(id, formData);
        success("Successful", "Campaign Updated Successfully");
      } else {
        await addCampaign(formData);
        success("Successful", "Campaign Added Successfully");
      }

      setSaveCampaignLoading(false);
      setAddCampaignsData(initialData);
      setSelectedFile(null);
      navigate("/campaigns");
    } catch (err) {
      errorMsg("Error", err?.message || err);
      setSaveCampaignLoading(false);
    }
  };
  const resetVideo = () => {
    setSelectedFile(null);
    setAddCampaignsData({ ...addCampaignsData, video: "" });
    inputRef.current.value = "";
  };

  const handleLocationChange = (selectedOption) => {
    const previousLocation = addCampaignsData.location;

    setAddCampaignsData({
      ...addCampaignsData,
      location: selectedOption?.label,
    });
    setFormErrors((prev) => ({ ...prev, location: "" }));

    // Refresh vehicles if type is vehicle
    if (addCampaignsData.type?.value === "vehicle") {
      setLoading(true);

      // ✅ Clear vehicle-related selections when changing location
      setAddCampaignsData((prev) => ({
        ...prev,
        location: selectedOption?.label,
        numberOfScreens: 0,
        numberOfScreensAvailable: 0,
      }));

      // ✅ Clear screens per vehicle type
      setScreensPerVehicleType({});

      getVehiclesWithType(
        selectedOption?.value,
        addCampaignsData.startDate,
        addCampaignsData.numberOfWeeks
      )
        .then((res) => {
          setVehicles(res?.data?.vehicles || {});
          setAvailableScreensByType(res?.data?.availableScreensByType || {});
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching vehicles:", error);
          setLoading(false);
        });
    }
  };

  const handleCheckboxChange = (restaurantId) => {
    let updatedSelection = [];

    setAddCampaignsData((prevData) => {
      updatedSelection = prevData.selectedRestaurants.includes(restaurantId)
        ? prevData.selectedRestaurants.filter((id) => id !== restaurantId)
        : [...prevData.selectedRestaurants, restaurantId];

      return {
        ...prevData,
        selectedRestaurants: updatedSelection,
        numberOfScreensAvailable: updatedSelection.length,
        numberOfScreens: updatedSelection.length,
      };
    });

    // ✅ Now this works because updatedSelection is defined above
    if (updatedSelection.length > 0) {
      setFormErrors((prev) => ({
        ...prev,
        selectedRestaurants: undefined,
      }));
    }
  };

  const handleRestaurantClick = (id) => {
    setSelectedRestaurantId(id); // Ensure we're setting the correct _id
    setIsModalOpen(true);
  };

  const handleCheckboxChangeForVehicle = async (vehicleType) => {
    if (isProcessingCheckbox) return;

    setIsProcessingCheckbox(true);

    const isSelected =
      addCampaignsData.selectedVehicleTypes?.includes(vehicleType);
    let updatedSelectedTypes = [
      ...(addCampaignsData.selectedVehicleTypes || []),
    ];
    let updatedSelectedVehicles = [
      ...(addCampaignsData.selectedVehicles || []),
    ];
    let updatedScreensPerVehicleType = { ...screensPerVehicleType };

    if (isSelected) {
      // Unchecking: Remove vehicle type and its vehicles
      updatedSelectedTypes = updatedSelectedTypes.filter(
        (type) => type !== vehicleType
      );
      const vehiclesToRemove =
        vehicles[vehicleType]?.map((v) => v.vehicleId) || [];
      updatedSelectedVehicles = updatedSelectedVehicles.filter(
        (vId) => !vehiclesToRemove.includes(vId)
      );
      delete updatedScreensPerVehicleType[vehicleType];
    } else {
      // Checking: Add vehicle type and its vehicles
      updatedSelectedTypes.push(vehicleType);

      const totalScreens =
        availableScreensByType[vehicleType]?.totalScreensAvailable || 0;

      // Calculate the number of screens to add (multiple of 10, max available)
      const screensToAdd = Math.max(10, Math.floor(totalScreens / 10) * 10);

      const availableVehicles =
        vehicles[vehicleType]?.filter((v) => v.availableScreens >= 1) || [];
      const vehiclesToAdd = availableVehicles
        .slice(0, screensToAdd)
        .map((v) => v.vehicleId);

      // Remove any existing vehicles of this type
      const existingVehiclesOfThisType =
        vehicles[vehicleType]?.map((v) => v.vehicleId) || [];
      updatedSelectedVehicles = updatedSelectedVehicles.filter(
        (vId) => !existingVehiclesOfThisType.includes(vId)
      );

      // Add the new vehicles
      updatedSelectedVehicles.push(...vehiclesToAdd);
      updatedScreensPerVehicleType[vehicleType] = screensToAdd;
    }

    // Update state
    setAddCampaignsData((prev) => ({
      ...prev,
      selectedVehicleTypes: updatedSelectedTypes,
      selectedVehicles: updatedSelectedVehicles,
      numberOfScreens: Object.values(updatedScreensPerVehicleType).reduce(
        (sum, num) => sum + num,
        0
      ),
      numberOfScreensAvailable: Object.values(
        updatedScreensPerVehicleType
      ).reduce((sum, num) => sum + num, 0),
    }));

    setScreensPerVehicleType(updatedScreensPerVehicleType);
    setIsProcessingCheckbox(false);
  };

  const isVehicleTypeSelected = (vehicleType) => {
    if (
      !addCampaignsData.selectedVehicles ||
      addCampaignsData.selectedVehicles.length === 0
    ) {
      return false;
    }

    // Check if any vehicles of this type are in the selectedVehicles array
    const vehiclesOfThisType = vehicles[vehicleType] || [];
    return vehiclesOfThisType.some((vehicle) =>
      addCampaignsData.selectedVehicles.includes(vehicle.vehicleId)
    );
  };

  const isRestaurantSelected = (restaurantId) => {
    return (
      addCampaignsData.selectedRestaurants?.includes(restaurantId) || false
    );
  };

  const updateTotalScreens = (screensData) => {
    const totalScreens = Object.values(screensData).reduce(
      (sum, num) => sum + num,
      0
    );

    console.log("🔥 Total Screens Calculated: " + totalScreens);

    setAddCampaignsData((prev) => ({
      ...prev,
      numberOfScreensAvailable: totalScreens,
      numberOfScreens: totalScreens, // ✅ Ensure `numberOfScreens` is updated before sending
    }));
  };

  // ✅ Update Selected Vehicles and their Screens
  const updateSelectedVehicles = (vehicleType, requiredScreens) => {
    setAddCampaignsData((prevData) => {
      const availableVehicles =
        vehicles[vehicleType]?.filter((v) => v.availableScreens >= 1) || [];

      // Ensure requiredScreens is a multiple of 10 and doesn't exceed available vehicles
      const validatedScreens = Math.min(
        Math.floor(requiredScreens / 10) * 10,
        Math.floor(availableVehicles.length / 10) * 10
      );

      const maxScreens = Math.max(10, validatedScreens); // Minimum 10 screens

      // Get vehicles to add (first X vehicles)
      const vehiclesToAdd = availableVehicles
        .slice(0, maxScreens)
        .map((v) => v.vehicleId);

      // Remove all vehicles of this type first
      const updatedVehicles = prevData.selectedVehicles.filter(
        (vId) => !vehicles[vehicleType]?.some((v) => v.vehicleId === vId)
      );

      // Add the newly selected vehicles
      updatedVehicles.push(...vehiclesToAdd);

      // Update screens per type
      const updatedScreensPerType = {
        ...screensPerVehicleType,
        [vehicleType]: maxScreens,
      };

      // Calculate total screens
      const totalScreens = Object.values(updatedScreensPerType).reduce(
        (sum, num) => sum + num,
        0
      );

      return {
        ...prevData,
        selectedVehicles: updatedVehicles,
        numberOfScreens: totalScreens,
        numberOfScreensAvailable: totalScreens,
      };
    });
  };
  // Add these components at the top of your file (or in a separate components file)
  const TableSkeletonLoader = ({ rows = 5, columns = 5 }) => {
    return (
      <div className="animate-pulse">
        <div className="grid grid-cols-5 gap-4 mb-4">
          {Array.from({ length: columns }).map((_, i) => (
            <div key={i} className="h-6 bg-gray-200 rounded"></div>
          ))}
        </div>
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="grid grid-cols-5 gap-4 mb-3">
            {Array.from({ length: columns }).map((_, j) => (
              <div key={j} className="h-4 bg-gray-100 rounded"></div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <AdminLayout title={id ? " Update Campaign" : "Add Campaign"}>
        <form onSubmit={handleSubmit} method="POST">
          <div className="gap-5 px-3 md:px-5 lg:px-5 py-0.5 md:py-1.5 lg:py-1.5  grid grid-cols-1 grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
            <div className="px-1 lg:px-5 md:px-5 lg:col-span-8 md:col-span-12 col-span-12">
              <div className="gap-4 py-0.5 md:py-3 lg:py-3 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                {/* Name field - half width on large screens, full on small */}
                <div className="lg:col-span-6 md:col-span-6 col-span-12">
                  <label
                    htmlFor="name"
                    className="block text-base font-semibold leading-6 text-gray-600"
                  >
                    Name
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter Name"
                      value={addCampaignsData?.name}
                      onChange={handleChange}
                      id="name"
                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellow sm:leading-6 focus:ring-transparent"
                      required
                    />
                  </div>
                </div>

                {/* Location field - half width on large screens, full on small */}
                <div className="lg:col-span-6 md:col-span-6 col-span-12">
                  <label
                    htmlFor="location"
                    className="block text-base font-semibold leading-6 text-gray-600"
                  >
                    Location
                  </label>
                  <div className="mt-2">
                    <Select
                      name="location"
                      id="location"
                      options={serviceLocationOptions}
                      value={serviceLocationOptions.find(
                        (option) => option.label === addCampaignsData?.location
                      )}
                      className={`basic-multi-select w-full ${
                        formErrors.location
                          ? "border border-red-500 rounded-md"
                          : ""
                      }`}
                      classNamePrefix="select-location"
                      onChange={handleLocationChange}
                    />
                    {formErrors.location && (
                      <p className="text-red-500 text-sm mt-1">
                        {formErrors.location}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="lg:col-span-6 md:col-span-12 sm:col-span-12 ">
                <label
                  htmlFor="company"
                  className="block text-base font-semibold leading-6 text-gray-600"
                >
                  Company
                </label>
                <div className="mt-2">
                  {id ? (
                    <input
                      type="text"
                      value={addCampaignsData?.company?.label || ""}
                      readOnly
                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellow sm:leading-6 focus:ring-transparent"
                    />
                  ) : (
                    <Select
                      id="company"
                      name="type"
                      options={addCompaniesData?.map((company) => ({
                        value: company?._id,
                        label: company?.name,
                      }))}
                      className="basic-multi-select"
                      classNamePrefix="select Type"
                      value={addCampaignsData?.company}
                      onChange={(selectedOption) => {
                        setAddCampaignsData({
                          ...addCampaignsData,
                          company: selectedOption,
                        });
                      }}
                      required
                    />
                  )}
                </div>
              </div>

              <div className="gap-4 py-0.5 md:py-3 lg:py-3 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                <div className="lg:col-span-4 md:col-span-12 col-span-12 ">
                  <label
                    htmlFor="date"
                    className="block text-base font-semibold leading-6 text-gray-600"
                  >
                    Start Date
                  </label>
                  <div className="mt-2">
                    <input
                      type="date"
                      name="startDate"
                      placeholder="Enter Date"
                      value={addCampaignsData?.startDate}
                      onChange={handleChange}
                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellow sm:leading-6 focus:ring-transparent"
                      required
                    />
                  </div>
                </div>
                <div className="lg:col-span-4 md:col-span-12 col-span-12 ">
                  <label
                    htmlFor="numberOfWeeks"
                    className="block text-base font-semibold leading-6 text-gray-600"
                  >
                    Number of Weeks
                  </label>
                  <div className="mt-2">
                    <input
                      type="number"
                      name="numberOfWeeks"
                      placeholder="Number of Weeks"
                      value={addCampaignsData?.numberOfWeeks}
                      onChange={handleChange}
                      min={1}
                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellow sm:leading-6 focus:ring-transparent"
                      required
                    />
                  </div>
                </div>
                <div className="lg:col-span-4 md:col-span-12 col-span-12 ">
                  <label
                    htmlFor="date"
                    className="block text-base font-semibold leading-6 text-gray-600"
                  >
                    End Date
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="endDate"
                      placeholder="End Date"
                      value={endDate}
                      readOnly
                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellow sm:leading-6 focus:ring-transparent"
                    />
                  </div>
                </div>
              </div>
              <div className="lg:col-span-6 md:col-span-6 col-span-12">
                <div className="gap-4 py-0.5 md:py-3 lg:py-3 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                  <div className="lg:col-span-6 md:col-span-12 sm:col-span-12 ">
                    <label
                      htmlFor="status"
                      className="block text-base font-semibold leading-6 text-gray-600"
                    >
                      Status
                    </label>
                    <div className="mt-2">
                      <Select
                        name="type"
                        id="status"
                        options={statusValues.map((status) => ({
                          value: status,
                          label: status,
                        }))}
                        value={addCampaignsData?.status}
                        className="basic-multi-select"
                        classNamePrefix="select Type"
                        onChange={(selectedOption) => {
                          setAddCampaignsData({
                            ...addCampaignsData,
                            status: selectedOption,
                          });
                        }}
                        required
                      />
                    </div>
                  </div>
                  <div className="lg:col-span-6 md:col-span-12 sm:col-span-12">
                    <label
                      htmlFor="type"
                      className="block text-base font-semibold leading-6 text-gray-600"
                    >
                      Type
                    </label>
                    <div className="mt-2">
                      <Select
                        name="type"
                        id="type"
                        options={typeValues}
                        value={addCampaignsData?.type}
                        className="basic-multi-select"
                        classNamePrefix="select Type"
                        onChange={(selectedOption) => {
                          if (!id) {
                            // Allow changes only in Add mode
                            setAddCampaignsData({
                              ...addCampaignsData,
                              type: selectedOption,
                            });
                          }
                        }}
                        isDisabled={!!id} // Disable the field if editing (id exists)
                        required
                      />
                    </div>
                  </div>
                </div>

                {addCampaignsData.type?.value === "vehicle" &&
                addCampaignsData.startDate ? (
                  <div className="col-span-12 xl:col-span-6 lg:col-span-6 ms-auto">
                    <h2 className="text-lg font-semibold text-gray-700 mb-2">
                      {id ? "Update Vehicle Types" : "Select Vehicle Types"}
                    </h2>
                    {loading ? (
                      <div className="border border-gray-200 rounded-lg p-4">
                        <TableSkeletonLoader rows={5} columns={5} />
                      </div>
                    ) : (
                      <div className="border-gray-300 rounded-lg">
                        <div className="relative overflow-x-auto shadow-sm sm:rounded-lg">
                          <div className="inline-block min-w-full align-middle">
                            <div className="overflow-hidden">
                              <table className="min-w-full divide-y divide-gray-200 md:min-w-[700px]">
                                <thead className="bg-gray-100">
                                  <tr>
                                    <th
                                      scope="col"
                                      className="px-3 py-3 text-center text-xs md:text-base font-medium tracking-wider w-16"
                                    >
                                      Select
                                    </th>
                                    <th
                                      scope="col"
                                      className="px-3 py-3 text-center text-xs md:text-base font-medium tracking-wider"
                                    >
                                      Vehicle Type
                                    </th>
                                    <th
                                      scope="col"
                                      className="px-3 py-3 text-center text-xs md:text-base font-medium tracking-wider"
                                    >
                                      Total Vehicles
                                    </th>
                                    <th
                                      scope="col"
                                      className="px-3 py-3 text-center text-xs md:text-base font-medium tracking-wider"
                                    >
                                      Screens
                                    </th>
                                    <th
                                      scope="col"
                                      className="px-3 py-3 text-center text-xs font-medium md:text-base tracking-wider"
                                    >
                                      Vehicles for Adverts
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                  {vehicleTypes.map((vehicleType) => {
                                    const typeName = vehicleType.name;
                                    const totalScreens =
                                      availableScreensByType[typeName]
                                        ?.totalScreensAvailable || 0;
                                    const isDisabled = totalScreens < 10; // Disable if less than 10 screens

                                    // Calculate maximum selectable screens (multiple of 10)
                                    const maxSelectableScreens =
                                      Math.floor(totalScreens / 10) * 10;

                                    return (
                                      <tr
                                        key={vehicleType._id}
                                        className="hover:bg-gray-50"
                                      >
                                        <td className="px-3 py-3 whitespace-nowrap text-center">
                                          <input
                                            type="checkbox"
                                            checked={isVehicleTypeSelected(
                                              typeName
                                            )}
                                            onChange={() =>
                                              handleCheckboxChangeForVehicle(
                                                typeName
                                              )
                                            }
                                            disabled={
                                              isDisabled || isProcessingCheckbox
                                            }
                                            className="h-4 w-4 rounded border-gray-300 text-yellow-600 focus:ring-yellow-500"
                                          />
                                        </td>
                                        <td className="px-3 py-3 whitespace-nowrap md:text-base text-center text-sm">
                                          {typeName}
                                        </td>
                                        <td className="px-3 py-3 whitespace-nowrap md:text-base text-center text-sm">
                                          {vehicles[typeName]?.length || 0}
                                        </td>
                                        <td className="px-3 py-3 whitespace-nowrap md:text-base text-center text-sm">
                                          {totalScreens}
                                        </td>
                                        <td className="px-3 py-3 whitespace-nowrap text-center">
                                          {isVehicleTypeSelected(typeName) &&
                                          maxSelectableScreens >= 10 ? (
                                            <select
                                              value={
                                                screensPerVehicleType[
                                                  typeName
                                                ] || 10
                                              }
                                              onChange={(e) => {
                                                const newValue = parseInt(
                                                  e.target.value,
                                                  10
                                                );
                                                setScreensPerVehicleType(
                                                  (prev) => {
                                                    const updatedScreens = {
                                                      ...prev,
                                                      [typeName]: newValue,
                                                    };
                                                    updateTotalScreens(
                                                      updatedScreens
                                                    );
                                                    updateSelectedVehicles(
                                                      typeName,
                                                      newValue
                                                    );
                                                    return updatedScreens;
                                                  }
                                                );
                                              }}
                                              className="w-20 text-center border rounded py-1 px-2"
                                            >
                                              {Array.from(
                                                {
                                                  length:
                                                    maxSelectableScreens / 10,
                                                },
                                                (_, i) => {
                                                  const value = (i + 1) * 10;
                                                  return (
                                                    <option
                                                      key={value}
                                                      value={value}
                                                    >
                                                      {value}
                                                    </option>
                                                  );
                                                }
                                              )}
                                            </select>
                                          ) : null}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        {formErrors.selectedVehicles && (
                          <p className="mt-2 text-base text-red-600 text-center">
                            {formErrors.selectedVehicles}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                ) : null}

                {addCampaignsData.type?.value === "restaurant" &&
                  restaurants.length > 0 && (
                    <div className="col-span-12 xl:col-span-6 lg:col-span-6 ">
                      <h2 className="text-lg font-semibold text-gray-700 mb-2 mt-2 ms-auto">
                        {id ? "Update Restaurants" : "Select Restaurants"}
                      </h2>

                      {loading ? (
                        <div className="border border-gray-200 rounded-lg p-4">
                          <TableSkeletonLoader rows={5} columns={2} />
                        </div>
                      ) : (
                        <div className="border-gray-300 rounded-lg">
                          <table className="table-auto w-full border-collapse md:min-w-[700px]">
                            <thead className="bg-gray-100">
                              <tr>
                                <th className="border px-6 py-3 text-center w-16">
                                  Select
                                </th>
                                <th className="border px-6 py-3 text-center">
                                  Restaurant Name
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {restaurants.map((restaurant) => (
                                <tr
                                  key={restaurant._id}
                                  className={`hover:bg-gray-50 ${
                                    restaurant.disabled
                                      ? "opacity-50 cursor-not-allowed"
                                      : ""
                                  }`}
                                >
                                  <td className="border px-6 py-3">
                                    <input
                                      type="checkbox"
                                      checked={isRestaurantSelected(
                                        restaurant._id
                                      )} // Use helper function
                                      onChange={() =>
                                        handleCheckboxChange(restaurant._id)
                                      }
                                      disabled={restaurant.disabled}
                                      className="h-4 w-4 rounded border-gray-300 text-yellow-600 focus:ring-yellow-500"
                                    />
                                  </td>
                                  <td
                                    className={`border px-6 py-3 text-lg cursor-pointer ${
                                      restaurant.disabled
                                        ? ""
                                        : "text-blue-500 hover:underline"
                                    }`}
                                    onClick={() =>
                                      !restaurant.disabled &&
                                      handleRestaurantClick(restaurant._id)
                                    }
                                  >
                                    {restaurant.name}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          {formErrors.selectedRestaurants && (
                            <p className="mt-2 text-base text-red-600 text-center">
                              {formErrors.selectedRestaurants}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  )}
              </div>

              {/* Show message only when there are no restaurants */}
              {addCampaignsData.type?.value === "restaurant" &&
                !loading &&
                restaurants.length === 0 && (
                  <p className="text-center text-red-500 font-semibold mt-2">
                    No restaurant screens available for the selected values.
                  </p>
                )}
              {/* Render the Modal */}
              <RestaurantDetailsModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                restaurantId={selectedRestaurantId}
              />

              <div className="lg:col-span-6 md:col-span-12 sm:col-span-12 ">
                <div className="mt-7 px-4 flex items-center justify-between">
                  <div className="relative flex items-start">
                    <div className="flex h-6 items-center">
                      <input
                        id="paid"
                        aria-describedby="paid"
                        name="paid"
                        type="checkbox"
                        checked={addCampaignsData?.paid}
                        onChange={handleChange}
                        className="h-4 w-4 rounded border-gray-100 text-yellowColor focus:ring-yellowColor"
                      />
                    </div>
                    <div className="ml-3 text-base leading-6">
                      <label
                        htmlFor="paid"
                        className="font-medium text-gray-700"
                      >
                        Paid
                      </label>
                    </div>
                  </div>
                  <p className="text-right text-lg font-semibold leading-6 text-gray-600">
                    Total Cost:{" "}
                    <span className="text-lg text-gray-600">
                      {isNaN(totalCost) ? "0.00" : totalCost.toFixed(2)} FCFA
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div className="lg:col-span-4 md:col-span-12 col-span-12">
              <div className="flex items-center justify-between">
                <label
                  htmlFor="companyLogo"
                  className="pl-2 block text-base font-semibold leading-6 text-gray-600"
                >
                  Add Video
                </label>
                <button
                  type="button"
                  className="flex justify-center rounded-md border border-gray-400 py-1 px-4 text-xs leading-6 text-gray-800 shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow"
                  onClick={resetVideo}
                >
                  Reset Video
                </button>
              </div>
              <div className="mt-2">
                <label
                  htmlFor="video"
                  className="mx-auto border-2 border-dashed border-gray-300 h-72 w-full inset-0 flex items-center justify-center cursor-pointer"
                >
                  {id && addCampaignsData?.video ? (
                    <video
                      src={`${baseURL}/s3/images/${addCampaignsData?.video?.name}`}
                      alt="Selected"
                      className="h-full w-full object-cover"
                      controls
                    />
                  ) : selectedFile ? (
                    <video
                      src={URL.createObjectURL(selectedFile)}
                      alt="Selected"
                      className="h-full w-full object-cover"
                      controls
                    />
                  ) : (
                    <AiOutlinePlus className="text-gray-400 h-14 w-14 p-2" />
                  )}
                </label>
                <input
                  ref={inputRef}
                  type="file"
                  name="video"
                  id="video"
                  className="hidden"
                  accept="video/*"
                  onChange={handleFileChange}
                />
              </div>
              {addCampaignsData?.type?.value && (
                <p className="text-base text-red-500 mt-2">
                  Note: Please upload a{" "}
                  {addCampaignsData.type.value === "restaurant"
                    ? "portrait"
                    : "landscape"}{" "}
                  video.
                </p>
              )}
            </div>
          </div>
          <div className=" mt-10 border-t-2 border-gray-200 px-3 pt-3 flex items-center justify-end gap-4 ">
            <button
              type="submit"
              disabled={saveCampaignLoading}
              className="flex justify-center rounded-md bg-yellowColor py-1.5 px-12 text-sm font-medium leading-6 text-gray-800 shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow"
            >
              {saveCampaignLoading ? "Loading..." : id ? " Update" : "Submit"}
            </button>
          </div>
        </form>
      </AdminLayout>
    </>
  );
}

export default AddCompaigns;
